import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ReportsService } from './../../apiclient';
import { ExcelExporterService } from './../../excel-exporter.service';
import { UserSessionService } from './../../UserSession/user-session.service';
import { CustomReportsImporterComponent } from '../custom-reports-importer/custom-reports-importer.component';

@Component({
  selector: 'ngx-reports-inport-confirmation',
  templateUrl: './reports-inport-confirmation.component.html',
  styleUrls: ['./reports-inport-confirmation.component.scss']
})
export class ReportsInportConfirmationComponent implements OnInit {


  @Input()
  reportsToSave: any

  @Input()
  formId:any

  @Input()
  importerDialogRef: NbDialogRef<CustomReportsImporterComponent>;

  registrosMessage:String

  constructor(private userSessionService: UserSessionService,private excelExporterService: ExcelExporterService,
    private reportsService: ReportsService, private dialogServiceRef: NbDialogRef<ReportsInportConfirmationComponent>,
    private toastService: NbToastrService,
    private excelExporterservice: ExcelExporterService) { }

  ngOnInit(): void {
    if(this.reportsToSave.valid.length == 0){
      this.registrosMessage='todos los registros'
    }else if(this.reportsToSave.notValid.length > 1){
      this.registrosMessage=`${this.reportsToSave.notValid.length} registros`;
    }else{

      this.registrosMessage='1 registro'
    }
  }

  cancelar(){
    this.dialogServiceRef.close();
  }

  descargar(){
    this.excelExporterService.exportCustomReport(this.reportsToSave.notValid.map(r => {
      return {form_data:r,form_name:'ErroresDeImportación'}
    }),this.formId,true).then(r => {

    })
  }

  importar(){
    this.dialogServiceRef.close();
    this.importerDialogRef.componentRef.instance.confirmImportarExcel();

  }

}
